import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	open: boolean;
	ownFunds: number;
	onClose: () => void;
	onAssign: () => void;
};

export const GoalCreatedPinDrawer: FC<Props> = ({
	open,
	ownFunds,
	onClose,
	onAssign,
}) => {
	const theme = useTheme();
	const { t } = useResource();
	const hasOwnFunds = ownFunds > 0;

	const description = hasOwnFunds
		? t(Resources.Goals.Detail.WelcomePin.WithOwnFunds.description, {
				amount: formatNumber(ownFunds),
			})
		: t(Resources.Goals.Detail.WelcomePin.WithoutOwnFunds.description);

	const ctaLabel = hasOwnFunds
		? t(Resources.Goals.Detail.WelcomePin.WithOwnFunds.cta)
		: t(Resources.Goals.Detail.WelcomePin.WithoutOwnFunds.cta);

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Goals.Detail.WelcomePin.title)}
		>
			<Stack px={2} pb={2.4} gap={2}>
				<Typography
					variant="body1"
					color={theme.palette.grey[600]}
					lineHeight="20px"
				>
					{description}
				</Typography>
				<Stack gap={1}>
					<Button variant="primary" onClick={onAssign}>
						{ctaLabel}
					</Button>
					<Button variant="secondary" onClick={onClose}>
						{t(Resources.Goals.Detail.WelcomePin.dismiss)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
